export default __webpack_public_path__ + "static/media/2302.a9efec5a.png";